import { Swiper, Parallax, Navigation, Pagination, Thumbs, Controller } from 'swiper'

export function initializeHomeCarousels() {
    Swiper.use([ Parallax, Navigation, Pagination, Thumbs, Controller ])
    
    const breakpoint = window.matchMedia('(max-width: 1023px)');
    
    let carouselSwiper;
    let thumbsSwiper;

    function breakpointChecker() {
       if (breakpoint.matches) {
            carouselSwiper?.destroy?.(true, true);
            thumbsSwiper?.destroy?.(true, true);
       } else {
            thumbsSwiper = new Swiper('.ideal__thumbs_row', {
                spaceBetween: 24,
                slidesPerView: 'auto',
                loop: true,
                loopedSlides: 10,
                freeMode: true,
                centeredSlides: true,
                observer: true,
                observeParents: true,
                parallax:true,
            })
        
            carouselSwiper = new Swiper(".ideal__carousel", {
                spaceBetween: 30,
                slidesPerView: 1.28,
                centeredSlides: true,
                loop: true,
                loopedSlides: 10,
                observer: true,
                observeParents: true,
                parallax:true,
    
                controller: {
                    control: thumbsSwiper,
                },
    
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
    
            thumbsSwiper.controller.control = carouselSwiper
       }
    };
    
    const reviewsSwiper = new Swiper(".new-reviews__items", {
        spaceBetween: 30,
        slidesPerView: 1.2,
        loop: true,
        centeredSlides: true,
        breakpoints: {
            320: {
                spaceBetween: 8,
                slidesPerView: 1.2,
            },
            480: {
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 1.5,
            },
            1025: {
                spaceBetween: 30,
                slidesPerView: 2,
            },
            1440: {
                slidesPerView: 2.5,
            }
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
    
    window.addEventListener('load', () => window.addEventListener('resize', breakpointChecker))
    breakpointChecker();
}


